import { format, parseISO } from 'date-fns';
import SideBarModal from '../modal/SideBarModal';
import {
  LoadedUser,
  Section,
  SectionRow,
  UnavailableTimes,
} from '../../interfaces';
import useUser from '../../hooks/global/useUser';
import { getEmployeeCalendarName } from '../../helpers/calendar';

interface Props {
  unavailableTimeData: {
    unavailableTime: UnavailableTimes;
    employeeId: string;
  } | null;
  onClose: () => void;
}

function ExternalEventSideBarModal({ unavailableTimeData, onClose }: Props) {
  const { user } = useUser<LoadedUser>();

  if (!unavailableTimeData) return null;

  const { unavailableTime, employeeId } = unavailableTimeData;

  const startDate = parseISO(unavailableTime.startDateTime);
  const endDate = parseISO(unavailableTime.endDateTime);

  const isAllDay =
    unavailableTime.fromTime === 0 && unavailableTime.toTime === 2400;

  const sections: Section[] = [
    {
      name: 'Event Details',
      rows: [
        {
          type: 'TEXT',
          label: 'Employee',
          value: [
            getEmployeeCalendarName(
              user.business?.employees ?? [],
              employeeId,
            ) || 'Unknown',
          ],
        },
        {
          type: 'TEXT',
          label: 'Reason',
          value: [unavailableTime.reason || 'No reason provided'],
        },
        {
          type: 'TEXT',
          label: 'Event Type',
          value: ['Google Calendar Event'],
        },
        {
          type: 'TEXT',
          label: 'Date',
          value: [format(startDate, 'EEEE, MMMM d, yyyy')],
        },
        isAllDay
          ? {
              type: 'TEXT',
              label: 'All Day',
              value: ['Yes'],
            }
          : {
              type: 'TEXT',
              label: 'Time',
              value: [
                `${format(startDate, 'h:mm a')} - ${format(endDate, 'h:mm a')}`,
              ],
            },
      ].filter(Boolean) as SectionRow[],
    },
  ];

  return (
    <SideBarModal
      modalOpen={!!unavailableTime}
      name="Event"
      sections={sections}
      setModalOpen={onClose}
    />
  );
}

export default ExternalEventSideBarModal;
